export enum SelectRecordingType {
  SCREEN = 'Screen',
  CAM = 'Camera',
  SCREEN_AND_CAM = 'Screen+Camera',
}

export enum RecordingToolAction {
  OPENED = 'Opened',
  APPLIED = 'Applied',
  CLOSED = 'Closed',
  REMOVED = 'Removed',
}
